export const HOMEOWNER_AUDIENCE = 'homeowners'
export const BUYER_AUDIENCE = 'buyers'
export const RIPE_FOR_REFI_AUDIENCE = 'ripe-for-refi'
export const KCL_AUDIENCE = 'key-client-list'
export const AI_VIDEO_AUDIENCE = 'ai-video'
